"use client";
import React, { useState, useMemo } from "react";
import { signOut, useSession } from "next-auth/react";
import { Dropdown } from "../ui/dropdown/Dropdown";
import { DropdownItem } from "../ui/dropdown/DropdownItem";
import { CircleUser, LogOut, Settings } from "lucide-react";

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "U";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const { data: session, status } = useSession();

  const username =
    session?.user?.name ||
    session?.user?.username ||
    (status === "loading" ? "" : "User");
  const fullName = session?.user?.fullName;
  const email = session?.user?.email || "";
  const initials = useMemo(
    () => getInitials(fullName || username),
    [fullName, username],
  );

  function toggleDropdown(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  }

  function closeDropdown() {
    setIsOpen(false);
  }
  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="flex items-center gap-2 text-text-secondary dark:text-gray-400 dropdown-toggle"
        aria-busy={status === "loading" && !(session as any)?.user}
      >
        {status === "loading" && !(session as any)?.user ? (
          <span className="flex items-center gap-2">
            <span className="h-10 w-10 rounded-full bg-gray-200 animate-pulse" />
            <span className="hidden lg:block h-4 w-24 rounded bg-gray-200 animate-pulse" />
          </span>
        ) : (
          <>
            <span className="flex items-center justify-center rounded-full h-10 w-10 bg-accent text-text-primary font-medium text-sm">
              {initials}
            </span>

            {/* <span className="hidden lg:block font-medium text-[15px] text-text-primary ">
              {username}
            </span> */}

            <svg
              className={`hidden lg:block stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200 ${
                isOpen ? "rotate-180" : ""
              } w-4 h-4`}
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.3125 8.65625L9 13.3437L13.6875 8.65625"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        )}
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className="absolute right-0 mt-4.25 flex w-65 flex-col rounded-2xl  bg-white p-3 shadow-theme-lg "
      >
        {/* <div>
          {username && (
            <span className="block text-theme-sm font-medium text-text-primary dark:text-gray-100">
              {username}
            </span>
          )}
          {email && (
            <span className="mt-0.5 block text-theme-xs text-text-secondary dark:text-gray-400">
              {email}
            </span>
          )}
        </div> */}

        <ul className="flex flex-col gap-1  pb-3 border-b border-gray-200 ">
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag="a"
              href="/dashboard"
              className="flex items-center gap-3 px-3 py-2  text-text-secondary rounded-lg group text-theme-sm hover:bg-accent "
            >
              <CircleUser className="h-4 w-4" />
              Profile
            </DropdownItem>
          </li>
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag="a"
              href="/settings"
              className="flex items-center gap-3 px-3 py-2  text-text-secondary rounded-lg group text-theme-sm hover:bg-accent "
            >
              <Settings className="h-4 w-4" />
              Settings
            </DropdownItem>
          </li>
        </ul>
        <button
          onClick={async () => {
            // Clear onboarding data on logout
            localStorage.removeItem("repayas-onboarding-storage");
            localStorage.removeItem("repayas-onboarding-user-id");
            await signOut({ redirect: false });
            window.location.href = "/signin";
          }}
          className="flex w-full items-center gap-3 px-3 py-2 mt-3  text-red-500 rounded-lg group text-theme-sm hover:bg-accent/25 hover:text-text-primary"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      </Dropdown>
    </div>
  );
}
